import parse from "url-parse";

import { sanitiseAssetName } from "@atlassian/wac-platform-sanitise-asset-name";

const isDevelopment = process.env["CLIENT_LIBRARY_ENV"] !== "production";

// Web Resource Manager (WRM)
// https://developer.atlassian.com/server/framework/atlassian-sdk/WRM-resource-loading-phases/
const isWRMResource = (url: string) =>
    url.includes("/batch.js") || url.includes("/batch.css");

const getWRMAssetName = (url: string) => {
    const [, resources] = /\/([\w.\-,:]*?)(?:,-|\/batch\.)/.exec(url) || [];
    const assetName = sanitiseAssetName(isDevelopment)(url);

    if (!resources) {
        return assetName;
    }

    return `wrm/${resources}/${assetName}`;
};

const getFileName = (url: string) =>
    isWRMResource(url)
        ? getWRMAssetName(url)
        : sanitiseAssetName(isDevelopment)(url);

// CHANGED
const sanitiseEndpoints = (url: string) => {
    const parsedUrl = parse(url, true);
    const fileName = parsedUrl.pathname.replace(/\/\d+$/i, "/<id>");

    return fileName;
};

// CHANGED
export const resourceTimingsConfig = {
    sanitiseEndpoints,
    mapResources: getFileName,
    hasTimingHeaders: (url: string) => isWRMResource(url),
    xhrFilter: (url: string) => url.includes("/rest/greenhopper/")
};
